import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ModalService } from '@purespectrum1/ui/modal';

import { AuthService } from '../../auth/auth.service';
import { MultiBuyerStateService } from '../services/multi-buyer/multi-buyer-state.service';
import { MultiBuyerModalComponent } from '../ui/multi-buyer-modal/multi-buyer-modal.component';

@Injectable({ providedIn: 'root' })
export class MultiBuyerGuard implements CanActivate {
  constructor(
    private readonly _multiBuyerState: MultiBuyerStateService,
    private readonly _modal: ModalService,
    private readonly _auth: AuthService
  ) {}

  canActivate(): Observable<boolean> {
    return this._auth
      .resolveAccessControlConfig()
      .pipe(switchMap(() => this._resolveAccess()));
  }

  private _resolveAccess(): Observable<boolean> {
    if (!this._multiBuyerState.isLoggedInAsMultiBuyer()) {
      return of(true);
    }

    if (this._multiBuyerState.isSelectedMultiBuyerCompany()) {
      return of(true);
    }

    return this._openSelectionAndWait();
  }

  private _openSelectionAndWait(): Observable<boolean> {
    const cmpId =
      this._multiBuyerState.selectedMultiBuyerCompany?.parentCompany ??
      this._auth.userCompanyId;

    const modalRef = this._modal.open(MultiBuyerModalComponent, {
      data: { cmpId },
    });

    return modalRef.onClose$.pipe(
      take(1),
      map(() => this._multiBuyerState.isSelectedMultiBuyerCompany())
    );
  }
}
